import type { CompetitionPageComponent } from "@/types/competitions";
import { Branding } from "@/components/OfferPage/Branding";
import { LowerContentBlock } from "../common/LowerContentBlock";
import styles from "./CompetitionPage.module.css";
import { CompetitionForm } from "./CompetitionForm";
import { LandingCarousel } from "@/components/landing/Carousel";
import { useBreakpoint } from "@/hooks/useBreakpoint";

export const CompetitionPage: CompetitionPageComponent = ({
    site,
    competitionPage,
    initialViewportWidth,
}) => {
    const { isMobileWidth } = useBreakpoint(768, initialViewportWidth);
    const offerPageUrl = competitionPage.offer_page_template_url;

    const galleryImages = competitionPage.gallery?.attributes.images.data?.map(
        (image) => {
            return {
                src: image.attributes.url,
                alt: image.attributes.alternativeText ?? '',
            };
        }
    ) ?? [];

    return (
        <main className={styles["page-container"]}>

            <Branding site={site} />
            <section className={styles["competition-container"]}>
                <div className={styles["competition-grid"]}>
                {isMobileWidth && (
                    <div className={styles["mobile-carousel"]}>
                        <LandingCarousel
                            slides={galleryImages}
                            hideControls={true}
                        />
                    </div>
                )}
                    <CompetitionForm
                        site={site}
                        competitionPage={competitionPage}
                        redirectUrl={offerPageUrl}
                    />
                    <div>
                        <LandingCarousel
                            slides={galleryImages}
                            hideImages={isMobileWidth}
                            hideControls={galleryImages.length === 1}
                        />
                    </div>
                </div>
            </section>
            <LowerContentBlock
                maxWidth={1200}
                lowerContentBlockText={
                    competitionPage.lower_block_content_html ?? ""
                }
                fromOffersPage={false}
            />
        </main>
    );
};
